import { render, staticRenderFns } from "./Chapter6_1.vue?vue&type=template&id=2a52be7e&scoped=true&"
import script from "./Chapter6_1.vue?vue&type=script&lang=js&"
export * from "./Chapter6_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52be7e",
  null
  
)

export default component.exports